import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { RateCardGridComponent } from './rate-card-grid.component';

@NgModule({
  imports: [VmeCommonModule, VmeDirectivesModule, VmePipesModule, VMEComponentsModule],
  declarations: [RateCardGridComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [RateCardGridComponent],
})
export class RateCardGridModule {}
